// extracted by mini-css-extract-plugin
module.exports = {"siteLogo":"logo_siteLogo__WXJdH"};